import routeName from '../constant';

const routes = [{
    path: 'insured-bank-acc',
    name: routeName.INSURED_BANK_ACC,
    component: () => import('@/views/aplCatl640and631/B7/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '被保險人指定匯款帳戶', leaveAlert: true, code: 'B7', unableBack: true },
}];

export default routes;
